import { Flex, isNullish, Text } from "@theorgchartdev/storybook";
import { getArchiveLabel, getPointInTime } from "./PointInTimeExplorer.utils";
import { appstr } from "@coreapp/utils/appstr";
import { Cappstr } from "@coreapp/utils/Cappstr";

export const getLastArchiveDateLabel = pit => {
  const lastPIT = pit?.lastpit;
  if (isNullish(lastPIT)) {
    return appstr("Never");
  }

  return getArchiveLabel(lastPIT);
};

export const PointInTimeStatus = props => {
  if (isNullish(props.chart)) {
    return <div />;
  }

  const pit = getPointInTime(props.chart);
  const hasAutoPITEnabled = pit?.enabled ?? false;

  return (
    <Flex direction="column" gap="8px">
      <Flex direction="row" gap="8px" alignItems="baseline" justifyContent="space-between">
        <Text modifier="bold" size="small">
          {appstr("pitenabled")}
        </Text>
        <Text colorModifier={hasAutoPITEnabled ? "success" : "grey"}>
          {hasAutoPITEnabled ? Cappstr("on") : Cappstr("Off")}
        </Text>
      </Flex>
      <Flex direction="row" gap="8px">
        <Text modifier="bold" size="xsmall">
          {appstr("lastpit")}:
        </Text>
        <Text size="xsmall">{getLastArchiveDateLabel(pit)}</Text>
      </Flex>
    </Flex>
  );
};
